import styled from "@emotion/styled";
import { gutterSizes, colors, fontWeights, mediaQuery, breakpoints } from "@gumtree/ui-library/src/base/theme";

export const StyledNotificationBox = styled.div`
    display: flex;
    padding: 20px;
    margin-bottom: ${gutterSizes.xlarge};
    background-color: ${colors.blade10};
    border-radius: ${gutterSizes.small};
    height: max-content;

    .icon {
        position: relative;
        color: ${colors.blade};

        &:before {
            position: absolute;
            top: 3px;
        }
    }

    ${mediaQuery.until(breakpoints.large)} {
        margin-top: ${gutterSizes.xlarge};
    }
`;

export const StyledContent = styled.span`
    margin-left: ${gutterSizes.large};
    color: ${colors.bark};
    font-weight: ${fontWeights.bold};
`;
